export type IPadWithSpace = (str: string, length: number) => string;

export function padWithSpace(str: string, length: number): string {
  let currentLength = str.length;
  let newString = str;
  if (currentLength < length) {
    while (currentLength < length) {
      newString += ' ';
      currentLength = newString.length;
    }
  }
  return newString;
}
